export interface DmpChatHistoryRefreshItem {
  chatHistoryId?: string | null
}

export interface DmpChatHistoryRefreshResult {
  data?: readonly DmpChatHistoryRefreshItem[]
}

export type DmpChatHistoryRefetch = () => Promise<DmpChatHistoryRefreshResult>

const DMP_CHAT_HISTORY_REFRESH_ATTEMPTS = 4
const DMP_CHAT_HISTORY_REFRESH_DELAY_MS = 500

export async function refetchDmpChatHistoryUntilVisible(
  chatHistoryId: string,
  refetch: DmpChatHistoryRefetch
): Promise<void> {
  for (let attempt = 0; attempt < DMP_CHAT_HISTORY_REFRESH_ATTEMPTS; attempt += 1) {
    const result = await refetch()
    if (result.data?.some((session) => session.chatHistoryId === chatHistoryId)) {
      return
    }

    if (attempt < DMP_CHAT_HISTORY_REFRESH_ATTEMPTS - 1) {
      await waitForDmpChatHistoryRefresh()
    }
  }
}

function waitForDmpChatHistoryRefresh(): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(resolve, DMP_CHAT_HISTORY_REFRESH_DELAY_MS)
  })
}
